import urlMealPlanStore from '@/CVI/Purchase/lib/urlMealPlanStore'

const saveMealPlan = ({ state }, { replace = false } = {}) => {
  urlMealPlanStore.save(state.mealPlanUrl, state.mealPlanDays, state.selectedTags, replace)
}

export default saveMealPlan
